import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import CharacterSwitcher from './CharacterSwitcher';
import RoleBadge from './RoleBadge';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const navigationItems = [
    { label: 'Dashboard', path: '/guild-dashboard', icon: 'LayoutDashboard' },
    { label: 'Progression', path: '/expansion-progression', icon: 'TrendingUp' },
    { label: 'Characters', path: '/character-management', icon: 'Users' },
    { label: 'Members', path: '/member-directory', icon: 'UserCircle' }
  ];

  const handleNavigation = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
  };

  const handleOpenDKP = () => {
    window.open('https://mmiscreants.opendkp.com/#/dkp', '_blank', 'noopener,noreferrer');
    setIsMobileMenuOpen(false);
  };

  const isActive = (path) => location?.pathname === path;

  return (
    <>
      <header className="header">
        <div className="header-content">
          <div className="header-logo">
            <div className="header-logo-icon">
              <Icon name="Shield" size={28} color="var(--color-primary)" />
            </div>
            <span className="header-logo-text">Maladapted Miscreants</span>
          </div>

          <nav className="header-nav">
            {navigationItems?.map((item) => (
              <button
                key={item?.path}
                onClick={() => handleNavigation(item?.path)}
                className={`header-nav-item ${isActive(item?.path) ? 'active' : ''}`}
              >
                {item?.label}
              </button>
            ))}
          </nav>

          <div className="header-actions">
            <button
              onClick={handleOpenDKP}
              className="header-nav-item"
              style={{
                backgroundColor: 'var(--color-primary)',
                color: 'white',
                padding: '0.5rem 1rem',
                borderRadius: '0.375rem',
                fontWeight: '600',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                transition: 'all 0.2s',
                border: 'none',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = 'var(--color-primary-dark)';
                e.target.style.transform = 'translateY(-1px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'var(--color-primary)';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              <Icon name="ExternalLink" size={16} />
              OpenDKP
            </button>
            <CharacterSwitcher />
            <RoleBadge role="officer" />
          </div>
        </div>
      </header>
      <button
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        className="mobile-menu-button"
        aria-label="Toggle mobile menu"
      >
        <Icon name={isMobileMenuOpen ? 'X' : 'Menu'} size={24} color="var(--color-foreground)" />
      </button>
      {isMobileMenuOpen && (
        <>
          <div 
            className="mobile-menu-overlay"
            onClick={() => setIsMobileMenuOpen(false)}
          />
          <div className="mobile-menu">
            <div className="mobile-menu-content">
              {navigationItems?.map((item) => (
                <button
                  key={item?.path}
                  onClick={() => handleNavigation(item?.path)}
                  className={`mobile-menu-item ${isActive(item?.path) ? 'active' : ''}`}
                >
                  <Icon name={item?.icon} size={20} className="inline-block mr-3" />
                  {item?.label}
                </button>
              ))}
              <button
                onClick={handleOpenDKP}
                className="mobile-menu-item"
                style={{
                  backgroundColor: 'var(--color-primary)',
                  color: 'white',
                  marginTop: '0.5rem',
                  fontWeight: '600'
                }}
              >
                <Icon name="ExternalLink" size={20} className="inline-block mr-3" />
                OpenDKP
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Header;